var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yaml-fieldtype-container relative"},[_c('div',{staticClass:"code-mode",domProps:{"textContent":_vm._s('yaml')}}),_vm._v(" "),_c('div',{ref:"codemirror"})])}
var staticRenderFns = []

export { render, staticRenderFns }